export default __webpack_public_path__ + "static/media/modal-waves-image-1.bc8c4986.jpg";